import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { isNumber } from 'util';
export function isObject(x: any): x is Object {
  return x != null && typeof x === 'object';
}
export function isArray(x: any):boolean{
    
    return Array.isArray(x);
    
    if(x==null){ return false;}
    if(isObject(x)===false){ false;}
    return (!x.length)? false: true;
}

export function empty(value: any): boolean {
  let tipo:string=typeof value;
    
  
    var isVazio=function(valor){
      switch (valor) {
        case "":
        case 0:
        case "0":
        case false:
        case null:  
          return true;
        default:
          return false;
      }  
    }
    if(isVazio(value)===true){
        return true;
    }
    switch(tipo){
       case "undefined":
        return true;
      case "object":
      case "Array":    
        return (Object.keys(value).length==0);
      case 'number':
         return isVazio(value);
      break;
      case 'string':
        return isVazio(value.trim());
      break;  
      case 'boolean':    
        return isVazio(value);
      default:
          return false;
    } 
    
    /**
     * function',
    '[object RegExp]'  : 'regexp',
    '[object Array]'   : 'array',
    '[object Date]'    : 'date',
    '[object Error]'   : 'error'
     * */    
}
@Injectable({
  providedIn: 'root'
})
export class InstiHelpers {
    arrayColumn(arra, name){
        var retorno=[];
        let x:number=0;
        for(x=0; x<arra.length; x++){
             if(isObject(arra[x])===false || empty(arra[x])){
                 continue;
             }
             if(arra[x].hasOwnProperty(name)===false){
                 continue;
             }
            retorno.push(arra[x][name]); 
        }
        return retorno;
     }
    arrayUnique(arra){
        var removeDuplicate=function(value, index, self) { 
                return self.indexOf(value) === index;
            }        
        return  isArray(arra) ? arra.filter(removeDuplicate) : arra;
    }
    empty(value):boolean{ return empty(value);}
    isObject(value){ return isObject(value);}
    isArray(value){ return isArray(value)}
    isNumber(value){ return !isNaN(value)}
    toInt(value,returnNaN?){ 
      let a = parseInt(value);
      return isNaN(a) ? (returnNaN===true? a: 0) : a;     
    }
    toFloat(value,returnNan?){
      return this.isNumber(value) ? (typeof value=='string' ? parseFloat(value) : value): (returnNan === true? 0 : value);
      
    }
    parseDateToBr(value){
      return value;
    }

    validarCPF(cpf) {	
      /*Disponivel em geradorcpf*/
      cpf = cpf.replace(/[^\d]+/g,'');	
      if(cpf == '') return false;	
      // Elimina CPFs invalidos conhecidos	
      if (cpf.length != 11 || 
        cpf == "00000000000" || 
        cpf == "11111111111" || 
        cpf == "22222222222" || 
        cpf == "33333333333" || 
        cpf == "44444444444" || 
        cpf == "55555555555" || 
        cpf == "66666666666" || 
        cpf == "77777777777" || 
        cpf == "88888888888" || 
        cpf == "99999999999")
          return false;		
      // Valida 1o digito	
      var add = 0;	
      for (let i=0; i < 9; i ++)	
        add += parseInt(cpf.charAt(i)) * (10 - i);	
        var rev = 11 - (add % 11);	

        if (rev == 10 || rev == 11){
          rev = 0;	
        }
        if (rev != parseInt(cpf.charAt(9))){
          return false;		
        }
      
      // Valida 2o digito	
      add = 0;	

      for (let i = 0; i < 10; i ++){
        add += parseInt(cpf.charAt(i)) * (11 - i);	
      }
      //calculo
      rev = 11 - (add % 11);	
      
      if (rev == 10 || rev == 11){
        rev = 0;	
      }
      if (rev != parseInt(cpf.charAt(10))){
        return false;		
      }
      return true;   
    }
}

